import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';
// import * as  domtoimage  from 'dom-to-image';
import * as moment from 'moment';

@Injectable()
export class FacilityProvider {

  URL = environment.ismUrl;
  FORM_URL = environment.formUrl
  NOTIFY_URL = environment.notifyUrl;

  constructor(public http: HttpClient, private storage: Storage) {
    console.log('Hello FacilityProvider Provider');
  }

  getMyBookings(all: boolean = false, page: number = 1){
    let today = moment().format('YYYY-MM-DD');
	  return this.getToken().then((val) => {
      if(val && !all){
        return this.http.get<Response>(this.getUrl(`/my/bookings`,val)+`&from_date=${today}&status=1&location=1`)
        .toPromise();
      }else if(val && all){
        return this.http.get<Response>(this.getUrl(`/my/bookings`,val)+`&location=1&page=${page}`)
        .toPromise();
      }
    });
  }

  cancelBooking(id, remarks){
	  return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/my/cancelbooking`,val),{
          id,
          remarks
        }).toPromise();
      }
    });
  }

  getLocations(type:string){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/${val.societyId}/locations`,val)+`${type?`&type=`+type:''}`).toPromise();
      }
    });
  }


  getForm(data){ 
    return this.getToken().then((val) => {
        if(val){
          return this.http.get<Response>(this.getFormUrl(`/v1/society/${val.societyId}/getfields`,val)+`&form_type=${data.form_type}&default=${data.default}`)
          .toPromise();
        }
  });
  }

  checkSlot(id, from, to){
    return this.getToken().then((val) => {
      if(val){
        console.log("checkSlot")
        from = encodeURIComponent(from)
        to = encodeURIComponent(to)
        return this.http.get<Response>(this.getUrl(`/${val.societyId}/${id}/bookedslots`,val)+`&from=${from}&to=${to}`)
        .toPromise();
      }
    });
  }

  bookSlot(id, from, to,data,referenceId, status=1){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/${val.societyId}/my/bookLocation`,val),{
          booking_from: from,
          booking_to: to,
          location_id: id,
          user_id: val.id,
          data : data,
          reference_id : referenceId ? referenceId : null,
          status : status,
        }).toPromise();
      }
    });
  }

  findBookings(locId: number, date: string){
    return this.getToken().then((val) => {
      return this.http.get<Response>(this.getUrl(`/my/bookings`,val)+`&date=${date}&location_id=${locId}&location=1`)
      .toPromise();
    });
  }

  checkSlotBooked(locId:number,date:string){
    return this.getToken().then((val) => {
      var uri =`/${val.societyId}/${locId}/bookings`
      if(date){
        uri += `/${date}`
      }
      return this.http.get<Response>(this.getUrl(uri,val))
      .toPromise();
    });
  }

  getParkingDetails(id){
    return this.getToken().then((val) => {
      return this.http.get<Response>(this.getUrl(`/society/${val.societyId}/bookings`,val)+`&reference_id=${id}`)
      .toPromise();
    });
  }


  // print(componentName) {
  //   var node = document.getElementById(componentName);
  //  return domtoimage.toPng(node).then(function (dataUrl) {
  //         return dataUrl;
  //   })
  //   .catch(function (error) {
  //       console.error('oops, something went wrong!', error);
  //       return error
  //   });
  // }

  getTemplate(id,type){
    return this.getToken().then((val) => {
      return this.http.get<Response>(this.getNotifyUrl(`/v1/gettemplatesbytype`,val)+`&customer_id=${id}&type=${type}`,{headers: {'Content-Type': 'application/json','Authorization': 'Basic MTExMToxMTEx'}})
      .toPromise();
    });
  }
  
  getToken(){
    return this.storage.get("loginDetails");
  }
  
  getFormUrl(link: string, val: any):string {
    return `${this.FORM_URL}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }
  getNotifyUrl(link: string, val: any):string {
    return `${this.NOTIFY_URL}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }
  getUrl(link: string, val: any):string {
    return `${this.URL}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }
  getBookingStatus(location){
    let res = 'Open'
    if(location.is_booking){      
      let bookingTime = location.rules && location.rules.active_slots ? location.rules.active_slots : null
      if(bookingTime){
        let today=moment()
        let day = today.day()
        if(bookingTime[day] && bookingTime[day].hrs){
          let isOpen = false
          bookingTime[day].hrs.forEach((time) => {
            let fromTime = (time.from).split(':');
            let toTime = (time.to).split(':');
            let ft = moment(today.format('YYYY-MM-DD')+ ' '+fromTime[0]+':'+fromTime[1]);
            let tt = moment(today.format('YYYY-MM-DD')+ ' '+toTime[0]+':'+toTime[1])
            if(isOpen || (today>ft && today<tt)) isOpen=true
          });
          if(!isOpen) res= 'Closed';
        }
      }
      console.log(res, bookingTime)
    }else{
      res='Inactive'
    }
    console.log(res)
    return res
  }
  getBookingTime(location){
    let timeStr = ''
    let bookingTime = location.rules && location.rules.active_slots ? location.rules.active_slots : null
    if(bookingTime){
      let today=moment()
      let day = today.day()
      bookingTime[day].hrs.forEach((time) => {
        let fromTime = (time.from).split(':');
        let toTime = (time.to).split(':');
        let ft = moment(today.format('YYYY-MM-DD')+ ' '+fromTime[0]+':'+fromTime[1]).format('hh:mm a');
        let tt = moment(today.format('YYYY-MM-DD')+ ' '+toTime[0]+':'+toTime[1]).format('hh:mm a')
        timeStr+=' | '+ft+' - '+tt
      });
    }
    return timeStr;
  }
}

export class Response{
  constructor(res){
    console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}




// WEBPACK FOOTER //
// ./src/providers/facility/facility.ts